import { FC, ReactElement } from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import IconTrash from '@shared/icons/IconTrash';
import { RedButton, TransparentButton } from '@shared/uikit/button';

interface IProps {
  open: boolean;
  title: string | ReactElement;
  subTitle: string | ReactElement;
  children?: ReactElement[] | ReactElement | string;
  confirmTitle?: string;
  onClose: () => void;
  onSubmit: () => void;
}

export const DeletePrompt: FC<IProps> = ({
  open,
  title,
  subTitle,
  onClose,
  onSubmit,
  confirmTitle = 'Удалить',
}) => {
  return (
    <Popup
      open={open}
      modal
      nested
      onClose={onClose}
      contentStyle={{
        backgroundColor: '#19181B',
        border: 'none',
        width: '340px',
        color: '#777777',
        padding: '30px',
        textAlign: 'center',
        borderRadius: '10px',
      }}
    >
      <div className="flex justify-center pb-[15px]">
        <div className="w-[30px] text-[#E23336] fill-[#E23336]">
          <IconTrash />
        </div>
      </div>
      <div className="pb-[15px]">{title}</div>
      <div className="text-[12px] pb-[20px]">{subTitle}</div>
      <div className="pb-[10px]">
        <RedButton onClick={() => onSubmit()} title={confirmTitle} />
      </div>
      <div>
        <TransparentButton onClick={() => onClose()} title="Отменить" />
      </div>
    </Popup>
  );
};
